// core
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CustomerResolver } from '@open-portal-app/core/resolvers/customer.resolver';
import { UserDetailsResolver } from '@open-portal-app/core/resolvers/user-details.resolver';

// components
import { MemberValidationComponent } from './member-validation/member-validation.component';


// will add a member resolver later
const routes: Routes = [
  { path: 'member-validation', component: MemberValidationComponent, pathMatch: 'full', resolve: { customer: CustomerResolver, user: UserDetailsResolver } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
